import React, { useEffect, useMemo, useState, useContext } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Label,
  Input,
  Container,
  Row,
  Col,
  Button,
  Collapse,
} from "reactstrap";
import Select from "react-select";
import {
  addChannelPartner,
  updateChannelPartnerById,
  getChannelPartnerById,
  getStates,
  getCities,
} from "action/channelPartner";
import { useDispatch, useSelector } from "react-redux";
import { urlDecodedId } from "components/CommonComponents/encodeDecodeFunction";
import { NotificationContext } from "components/CommonComponents/NotificationProvider";
import { useParams } from "react-router-dom";
import {
  REGEX,
  MAX_FILE_SIZE,
  SELECT_CUSTOM_STYLES,
} from "constants/CommonConstants";
import AdminHeader from "components/Headers/AdminHeader";
import { useLocation, useNavigate } from "react-router-dom";
import { addCity } from "action/channelPartner";
import AddNewCityModal from "components/CommonComponents/AddNewCityModal";
import CreatableSelect from "components/CommonComponents/CreatableSelect";
import CommonModal from "components/CommonComponents/CommonModal";
import {
  channelPartnerFieldToSectionMap,
  channelPartnerSectionLabels,
} from "components/constant";

const ALLOWED_LOGO_TYPES = ["image/png", "image/jpeg", "image/jpg"];

const ALLOWED_DOCUMENT_TYPES = [
  "application/pdf",
  "image/png",
  "image/jpeg",
  "image/jpg",
];

export const initialState = {
  organizationName: { value: "", originalValue: "", error: "" },
  contactPersonFirstName: { value: "", originalValue: "", error: "" },
  contactPersonLastName: { value: "", originalValue: "", error: "" },
  contactPersonEmail: { value: "", originalValue: "", error: "" },
  contactPersonMobile: { value: "", originalValue: "", error: "" },
  alternateMobileNumber: { value: "", originalValue: "", error: "" },
  gstNo: { value: "", originalValue: "", error: "" },
  panNo: { value: "", originalValue: "", error: "" },
  lineOne: { value: "", originalValue: "", error: "" },
  lineTwo: { value: "", originalValue: "", error: "" },
  landmark: { value: "", originalValue: "", error: "" },
  stateID: { value: "", originalValue: "", error: "" },
  cityID: { value: "", originalValue: "", error: "" },
  pincode: { value: "", originalValue: "", error: "" },
  companyLogo: { value: null, originalValue: null, error: "" },
  supportingDocuments: { value: [], originalValue: [], error: "" },
  deletecompanylogo: {
    value: false,
    originalValue: false,
    error: "",
  },
  deleteddocumentids: {
    value: [],
    originalValue: [],
    error: "",
  },
  status: { value: "ACTIVE", originalValue: "ACTIVE", error: "" },
};

function AddChannelPartner() {
  const authData = JSON.parse(localStorage.getItem("p") || "{}");
  const role = authData?.role;
  const { notify } = useContext(NotificationContext);
  const { id: encodedId } = useParams();
  const dispatch = useDispatch();
    const states =
    useSelector((state) => state.channelPartner.states?.data?.states) || [];
     const cities =
    useSelector((state) => state.channelPartner.cities?.data?.cities) || [];
  const navigate = useNavigate();
  const location = useLocation();
  const mode = location.state?.mode || "add";
  const decodedId =
    encodedId && mode === "edit" ? urlDecodedId(encodedId) : null;
  const [addChannelFormData, setAddChannelFormData] = useState(initialState);
  const [isSaving, setIsSaving] = useState(false);
  const [showLoaderOnCity, setShowLoaderOnCity] = useState(false);
  const [open, setOpen] = useState({
    basic: true,
    business: false,
    documents: false,
    system: false,
  });

  const [showAddCityModal, setShowAddCityModal] = useState({
    isopen: false,
    stateName: null,
    stateID: null,
  });

  const [documentModal, setDocumentModal] = useState({
    isOpen: false,
    url: "",
    title: "",
    isPdf: false,
  });

  const closeDocument = () => {
    setDocumentModal({
      isOpen: false,
      url: "",
      title: "",
      isPdf: false,
    });
  };
  const [newCityName, setNewCityName] = useState("");

  // Prefill form data when in edit mode
  const fetchChannelPartnerData = async (id) => {
    try {
      const res = await getChannelPartnerById(id);

      if (res?.code === 200) {
        setAddChannelFormData({
          organizationName: {
            value: res.data.organizationName || "",
            originalValue: res.data.organizationName || "",
            error: "",
          },

          contactPersonFirstName: {
            value: res.data.userID?.firstName || "",
            originalValue: res.data.userID?.firstName || "",
            error: "",
          },

          contactPersonLastName: {
            value: res.data.userID?.lastName || "",
            originalValue: res.data.userID?.lastName || "",
            error: "",
          },

          contactPersonEmail: {
            value: res.data.userID?.email || "",
            originalValue: res.data.userID?.email || "",
            error: "",
          },

          contactPersonMobile: {
            value: res.data.userID?.mobile || "",
            originalValue: res.data.userID?.mobile || "",
            error: "",
          },

          gstNo: {
            value: res.data.gstNo || "",
            originalValue: res.data.gstNo || "",
            error: "",
          },

          panNo: {
            value: res.data.panNo || "",
            originalValue: res.data.panNo || "",
            error: "",
          },

          lineOne: {
            value: res.data.lineOne || "",
            originalValue: res.data.lineOne || "",
            error: "",
          },

          lineTwo: {
            value: res.data.lineTwo || "",
            originalValue: res.data.lineTwo || "",
            error: "",
          },

          landmark: {
            value: res.data.landmark || "",
            originalValue: res.data.landmark || "",
            error: "",
          },

          stateID: {
            value: res.data.city?.state?.ID || "",
            originalValue: res.data.city?.state?.ID || "",
            error: "",
          },

          cityID: {
            value: res.data.city?.ID || "",
            originalValue: res.data.city?.ID || "",
            error: "",
          },

          pincode: {
            value: res.data.pincode || "",
            originalValue: res.data.pincode || "",
            error: "",
          },

          companyLogo: {
            value: res.data.companyLogoImageURL || null,
            originalValue: res.data.companyLogoImageURL || null,
            error: "",
          },

          supportingDocuments: {
            value:
              res.data.userDocuments?.map((doc) => ({
                id: doc.ID,
                file: null,
                preview: doc.documentPath,
                name: doc.documentPath.split("/").pop(),
                type: doc.documentPath.toLowerCase().endsWith(".pdf")
                  ? "application/pdf"
                  : "image",
              })) || [],

            originalValue:
              res.data.userDocuments?.map((doc) => ({
                id: doc.ID,
                file: null,
                preview: doc.documentPath,
                name: doc.documentPath.split("/").pop(),
                type: doc.documentPath.toLowerCase().endsWith(".pdf")
                  ? "application/pdf"
                  : "image",
              })) || [],
            error: "",
          },

          deletecompanylogo: {
            value: false,
            originalValue: false,
            error: "",
          },

          deleteddocumentids: {
            value: [],
            originalValue: [],
            error: "",
          },

          status: {
            value: res.data.userID?.status || "ACTIVE",
            originalValue: res.data.userID?.status || "ACTIVE",
            error: "",
          },
        });

        // fetch cities once state is known
        if (res.data.city?.state?.ID) {
          fetchCitiesForState(res.data.city.state.ID);
        }
      } else {
        const message = Array.isArray(res?.message)
          ? res.message
              .map((err) => (err.Msg ? err.Msg : JSON.stringify(err)))
              .join(", ")
          : res?.message || "Failed to load Channel Partner details!";
        notify("danger", message);
      }
    } catch (error) {
      notify(
        "danger",
        error?.message || "Something went wrong while fetching Channel Partner",
      );
    }
  };

  // Prefill form data when in edit mode
  useEffect(() => {
    getStates(dispatch);
  }, [dispatch]);

  useEffect(() => {
    if (mode !== "edit" || !decodedId) return;

    fetchChannelPartnerData(decodedId);
  }, [mode, decodedId]);

  const stateOptions = useMemo(() => {
    return states.map((r) => ({
      value: r.ID,
      label: r.name,
    }));
  }, [states]);

  const cityOptions = useMemo(() => {
    return cities.map((c) => ({
      value: c.ID,
      label: c.name,
    }));
  }, [cities]);

  const fetchCitiesForState = (stateID) => {
    const cityFilter = JSON.stringify([
      {
        field: "StateID",
        condition: "eq",
        filterValues: [String(stateID)],
      },
    ]);

    getCities(dispatch, cityFilter);
  };

  const toggle = (key) => setOpen((prev) => ({ ...prev, [key]: !prev[key] }));

  const handleViewFile = (src, type = "") => {
    if (!src) return;

    setDocumentModal({
      isOpen: true,
      url: src,
      title: "Document Preview",
      isPdf: type === "application/pdf",
    });
  };

  const getValidationError = (name, value) => {
    const trimmedValue = typeof value === "string" ? value.trim() : value;

    switch (name) {
      case "organizationName":
        return !trimmedValue
          ? "Please enter organization name"
          : !REGEX.ALPHABETS_NUM_SPACE_SPECIAL_SYMBOLS_ALLOWED.test(
                trimmedValue,
              )
            ? "Organization name contains invalid characters"
            : "";

      case "contactPersonFirstName":
        return !trimmedValue
          ? "Please enter first name"
          : !REGEX.ALPHABETS_NUM_SPACE_SPECIAL_SYMBOLS_ALLOWED.test(
                trimmedValue,
              )
            ? "Contact person name must contain only letters and spaces"
            : "";

      case "contactPersonLastName":
        return !trimmedValue
          ? "Please enter last name"
          : !REGEX.ALPHABETS_NUM_SPACE_SPECIAL_SYMBOLS_ALLOWED.test(
                trimmedValue,
              )
            ? "Contact person name must contain only letters and spaces"
            : "";

      case "contactPersonEmail":
        return !trimmedValue
          ? "Please enter email"
          : !REGEX.EMAIL_REGEX.test(trimmedValue)
            ? "Please enter a valid email"
            : "";

      case "contactPersonMobile":
        return !value
          ? "Please enter mobile number"
          : value.length !== 10
            ? "Mobile number must be 10 digits"
            : !REGEX.PHONE_NO_REGEX.test(value)
              ? "Please enter a valid mobile number"
              : "";

      case "gstNo":
        return !trimmedValue
          ? "Please enter gst number"
          : !REGEX.GST_REGEX.test(trimmedValue)
            ? "Invalid gst number"
            : "";

      case "panNo":
        return !trimmedValue
          ? "Please enter pan number"
          : !REGEX.PAN_REGEX.test(trimmedValue)
            ? "Invalid pan number"
            : "";

      case "lineOne":
        return !trimmedValue
          ? "Please enter address line 1"
          : trimmedValue.length > 150
            ? "Address line 1 cannot exceed 150 characters"
            : "";

      case "lineTwo":
        return trimmedValue && trimmedValue.length > 150
          ? "Address line 2 cannot exceed 150 characters"
          : "";

      case "landmark":
        return trimmedValue && trimmedValue.length > 150
          ? "Landmark cannot exceed 150 characters"
          : "";

      case "companyLogo":
        if (!value || typeof value === "string") return "";

        if (!ALLOWED_LOGO_TYPES.includes(value.type)) {
          return "Only PNG, JPG and JPEG files are allowed.";
        }

        if (value.size > MAX_FILE_SIZE) {
          return `Company logo should not exceed ${
            MAX_FILE_SIZE / (1024 * 1024)
          } MB.`;
        }

        return "";

      case "supportingDocuments":
        for (const file of value) {
          if (file.file) {
            if (!ALLOWED_DOCUMENT_TYPES.includes(file.file.type)) {
              return "Only PDF, PNG, JPG and JPEG files are allowed.";
            }

            if (file.file.size > MAX_FILE_SIZE) {
              return `Each document should not exceed ${
                MAX_FILE_SIZE / (1024 * 1024)
              } MB.`;
            }
          }
        }

        return "";

      case "stateID":
        return !value ? "Please select state" : "";

      case "cityID":
        return !value ? "Please select city" : "";

      case "pincode":
        return !value
          ? "Please enter pincode"
          : value.length !== 6
            ? "Pincode must be 6 digits"
            : "";

      default:
        return "";
    }
  };

  const formatSections = (sections) => {
    if (sections.length === 1) return sections[0];
    if (sections.length === 2) return sections.join(" and ");

    return `${sections.slice(0, -1).join(", ")} and ${sections.at(-1)}`;
  };

  const validateForm = () => {
    let newChannelPartner = { ...addChannelFormData };
    let hasError = false;

    let sectionsToOpen = {
      basic: false,
      business: false,
      documents: false,
      system: false,
    };

    const errorSections = new Set();

    Object.keys(newChannelPartner).forEach((key) => {
      newChannelPartner[key] = {
        ...newChannelPartner[key],
        error: getValidationError(key, newChannelPartner[key].value),
      };
    });

    for (const key in newChannelPartner) {
      if (newChannelPartner[key].error) {
        hasError = true;

        const section = channelPartnerFieldToSectionMap[key];

        if (section) {
          sectionsToOpen[section] = true;
          errorSections.add(channelPartnerSectionLabels[section]);
        }
      }
    }

    if (hasError) {
      setOpen((prev) => ({
        ...prev,
        ...sectionsToOpen,
      }));
    }

    setAddChannelFormData(newChannelPartner);

    return {
      isValid: !hasError,
      errorSections: [...errorSections],
    };
  };

  const getUpdatedPayload = () => {
    const formData = new FormData();
    const updatedFields = {};

    Object.keys(addChannelFormData).forEach((key) => {
      if (
        key === "companyLogo" ||
        key === "supportingDocuments" ||
        key === "deletecompanylogo" ||
        key === "deleteddocumentids"
      ) {
        return;
      }

      const field = addChannelFormData[key];

      if (field.value !== field.originalValue) {
        updatedFields[key] = field.value;
      }
    });

    if (Object.keys(updatedFields).length > 0) {
      formData.append("channelpartner", JSON.stringify(updatedFields));
    }

    if (addChannelFormData.companyLogo.value instanceof File) {
      formData.append("companylogo", addChannelFormData.companyLogo.value);
    }

    if (addChannelFormData.deletecompanylogo.value) {
      formData.append("deletecompanylogo", "true");
    }

    if (addChannelFormData.deleteddocumentids.value.length > 0) {
      formData.append(
        "deleteddocumentids",
        JSON.stringify(addChannelFormData.deleteddocumentids.value),
      );
    }

    addChannelFormData.supportingDocuments.value.forEach((item) => {
      if (item.file) {
        formData.append("companydocument", item.file);
      }
    });

    return formData;
  };

  const handleSave = async (e) => {
    e.preventDefault();

    const { isValid, errorSections } = validateForm();

    if (!isValid) {
      const gstError =
        addChannelFormData.gstNo.error &&
        addChannelFormData.gstNo.error === "Invalid gst number";

      const panError =
        addChannelFormData.panNo.error &&
        addChannelFormData.panNo.error === "Invalid pan number";

      if (gstError && panError) {
        notify("danger", "Please enter valid gst Number and pan Number");
      } else if (gstError) {
        notify("danger", "Please enter valid gst Number");
      } else if (panError) {
        notify("danger", "Please enter valid pan Number");
      } else {
        notify(
          "danger",
          `Please complete the required fields in ${formatSections(
            errorSections,
          )} before saving.`,
        );
      }

      return;
    }

    try {
      setIsSaving(true);
      let res;

      if (decodedId) {
        const patchFormData = getUpdatedPayload();

        if (![...patchFormData.keys()].length) {
          notify("info", "No changes detected");
          setIsSaving(false);
          return;
        }

        res = await updateChannelPartnerById(decodedId, patchFormData);
      } else {
        const formData = new FormData();

        const payload = {
          organizationName: addChannelFormData.organizationName.value,
          contactPersonFirstName:
            addChannelFormData.contactPersonFirstName.value,
          contactPersonLastName: addChannelFormData.contactPersonLastName.value,
          contactPersonEmail: addChannelFormData.contactPersonEmail.value,
          contactPersonMobile: addChannelFormData.contactPersonMobile.value,
          gstNo: addChannelFormData.gstNo.value,
          panNo: addChannelFormData.panNo.value,
          countryID: 1,
          stateID: addChannelFormData.stateID.value,
          cityID: addChannelFormData.cityID.value,
          lineOne: addChannelFormData.lineOne.value,
          lineTwo: addChannelFormData.lineTwo.value,
          landmark: addChannelFormData.landmark.value,
          pincode: addChannelFormData.pincode.value,
          status: addChannelFormData.status.value,
        };

        formData.append("channelpartner", JSON.stringify(payload));

        if (addChannelFormData.companyLogo.value instanceof File) {
          formData.append("companylogo", addChannelFormData.companyLogo.value);
        }

        addChannelFormData.supportingDocuments.value.forEach((item) => {
          if (item.file) {
            formData.append("companydocument", item.file);
          }
        });

        res = await addChannelPartner(formData);
      }

      if (res?.code === 200) {
        notify(
          "success",
          res?.message ||
            (decodedId
              ? "Channel partner updated successfully!"
              : "Channel partner added successfully!"),
        );

        navigate(
          decodedId
            ? role === "SUPER_ADMIN"
              ? `/super-admin/channel-partner/${encodedId}/details`
              : `/admin/channel-partner/${encodedId}/details`
            : role === "SUPER_ADMIN"
              ? "/super-admin/channel-partner"
              : "/admin/channel-partner",
        );
      } else {
        const message = Array.isArray(res?.message)
          ? res.message.map((err) => err.Msg).join(", ")
          : typeof res?.message === "object"
            ? res.message.Msg
            : res?.message ||
              `Failed to ${mode === "edit" ? "update" : "add"} channel partner`;

        notify("danger", message);
      }
    } catch {
      notify("danger", "Something went wrong");
    } finally {
      setIsSaving(false);
    }
  };

  const handleOnCancel = () => {
    setAddChannelFormData(initialState);
    // navigate("/admin/channel-partner");
    navigate(
      mode === "edit"
        ? role === "SUPER_ADMIN"
          ? `/super-admin/channel-partner/${encodedId}/details`
          : `/admin/channel-partner/${encodedId}/details`
        : role === "SUPER_ADMIN"
          ? "/super-admin/channel-partner"
          : "/admin/channel-partner",
    );
  };

  const removeDocument = (index) => {
    setAddChannelFormData((prev) => {
      const removedDoc = prev.supportingDocuments.value[index];

      return {
        ...prev,

        supportingDocuments: {
          ...prev.supportingDocuments,
          value: prev.supportingDocuments.value.filter((_, i) => i !== index),
          error: "",
        },

        deleteddocumentids: {
          ...prev.deleteddocumentids,
          value: removedDoc?.id
            ? [...prev.deleteddocumentids.value, removedDoc.id]
            : prev.deleteddocumentids.value,
        },
      };
    });
  };

  const handleSupportingDocsChange = (e) => {
    const files = Array.from(e.target.files);

    let error = "";
    const validFiles = [];

    for (const file of files) {
      if (!ALLOWED_DOCUMENT_TYPES.includes(file.type)) {
        error = "Only PDF, PNG, JPG and JPEG files are allowed.";
        break;
      }

      if (file.size > MAX_FILE_SIZE) {
        error = `Each document should not exceed ${
          MAX_FILE_SIZE / (1024 * 1024)
        } MB.`;
        break;
      }

      validFiles.push({
        file,
        preview: URL.createObjectURL(file),
        name: file.name,
        type: file.type,
      });
    }

    if (error) {
      setAddChannelFormData((prev) => ({
        ...prev,
        supportingDocuments: {
          ...prev.supportingDocuments,
          error,
        },
      }));

      notify("danger", error);
      e.target.value = "";
      return;
    }

    setAddChannelFormData((prev) => ({
      ...prev,
      supportingDocuments: {
        ...prev.supportingDocuments,
        value: [...prev.supportingDocuments.value, ...validFiles].slice(0, 5),
        error: "",
      },
    }));

    e.target.value = "";
  };

  const SectionHeader = ({ title, isOpen, onClick }) => (
    <div className="d-flex align-items-center cursor" onClick={onClick}>
      <i className={`fa fa-chevron-${isOpen ? "up" : "down"}`} />
      <h5 className="ml-2 mb-0 section-header-title">{title}</h5>
    </div>
  );

  const handleInputChange = (field, value) => {
    setAddChannelFormData((prev) => {
      const updatedState = {
        ...prev,
        [field]: {
          ...prev[field],
          value,
          error: "",
        },
      };

      if (field === "stateID") {
        updatedState.cityID = { ...prev.cityID, value: "", error: "" };
        updatedState.pincode = { ...prev.pincode, value: "", error: "" };
      }

      if (field === "cityID") {
        updatedState.pincode = { ...prev.pincode, value: "", error: "" };
      }

      if (
        field === "contactPersonMobile" ||
        field === "alternateMobileNumber" ||
        field === "pincode"
      ) {
        if (!REGEX.ONLY_DIGITS_REGEX.test(value)) {
          return {
            ...prev,
          };
        }

        return {
          ...prev,
          [field]: {
            ...prev[field],
            value,
            error: "",
          },
        };
      }

      return updatedState;
    });
  };

  //on blur to get if any validation error exits
  const handleOnBlur = (name, value) => {
    const trimmedValue = typeof value === "string" ? value.trim() : value;
    const error = getValidationError(name, trimmedValue);
    setAddChannelFormData((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        value: trimmedValue,
        error,
      },
    }));
  };

  const handleImageChange = (file) => {
    if (!file) return;

    const error = getValidationError("companyLogo", file);

    if (error) {
      setAddChannelFormData((prev) => ({
        ...prev,
        companyLogo: {
          ...prev.companyLogo,
          value: null,
          error,
        },
      }));

      notify("danger", error);
      return;
    }

    setAddChannelFormData((prev) => ({
      ...prev,
      companyLogo: {
        ...prev.companyLogo,
        value: file,
        error: "",
      },
      deletecompanylogo: {
        ...prev.deletecompanylogo,
        value: false,
      },
    }));
  };

  const logoSrc =
    typeof addChannelFormData.companyLogo.value === "string"
      ? addChannelFormData.companyLogo.value
      : addChannelFormData.companyLogo.value
        ? URL.createObjectURL(addChannelFormData.companyLogo.value)
        : null;

  const handleRemove = () => {
    setAddChannelFormData((prev) => ({
      ...prev,
      companyLogo: {
        ...prev.companyLogo,
        value: null,
        error: "",
      },

      deletecompanylogo: {
        ...prev.deletecompanylogo,
        value: true,
      },
    }));
  };

  const handleOpenCityModal = () => {
    setShowAddCityModal({
      isopen: true,
      stateID: addChannelFormData.stateID.value,
      stateName: stateOptions.find(
        (s) => s.value === addChannelFormData.stateID.value,
      )?.label,
    });
  };

  const handleSaveNewCity = async (stateID) => {
    setShowLoaderOnCity(true);
    try {
      const res = await addCity({
        stateID: stateID,
        name: newCityName,
        status: "ACTIVE",
      });
      if (res?.code === 200) {
        notify("success", res?.message || "City added successfully");
        fetchCitiesForState(stateID);
        setShowAddCityModal({ isopen: false, stateID: null, stateName: null });
        setNewCityName("");
      } else {
        const message = Array.isArray(res?.message)
          ? res.message
              .map((err) => (err.Msg ? err.Msg : JSON.stringify(err)))
              .join(", ")
          : res?.message || "Failed to add city";
        notify("danger", message);
      }
    } catch (error) {
      notify("danger", error?.message || "Failed to add city");
    } finally {
      setShowLoaderOnCity(false);
    }
  };

  const handleCancelAddCity = () => {
    setShowAddCityModal({ isopen: false, stateID: null, stateName: null });
    setNewCityName("");
  };

  return (
    <>
      <AdminHeader />
      {isSaving && (
        <div className="logout-overlay">
          <div className="logout-card">
            <i className="fa fa-spinner fa-spin fa-2x text-deep-blue mb-4" />
            <div className="font-weight-bold text-dark">
              Saving information... Please wait.
            </div>
          </div>
        </div>
      )}
      <Container fluid className="mt--6">
        <Row className="justify-content-center">
          <Col>
            <div
              className="d-flex align-items-center cursor text-white"
              onClick={() =>
                navigate(
                  mode === "edit"
                    ? role === "SUPER_ADMIN"
                      ? `/super-admin/channel-partner/${encodedId}/details`
                      : `/admin/channel-partner/${encodedId}/details`
                    : role === "SUPER_ADMIN"
                      ? "/super-admin/channel-partner"
                      : "/admin/channel-partner",
                )
              }
            >
              <i className="fa-solid fa-angle-left mr-2" />
              <span className="font-weight-bold">Back</span>

              {/* <h3 className="mb-0">
                {mode === "edit" ? "Edit Instructor" : "Add Instructor"}
              </h3> */}
            </div>
            {/*basic info details*/}
            <Card className="mb-3 mt-3">
              <CardHeader>
                <SectionHeader
                  title="Basic Information"
                  isOpen={open.basic}
                  onClick={() => toggle("basic")}
                />
              </CardHeader>
              <Collapse isOpen={open.basic}>
                <CardBody>
                  <Row>
                    <Col md="4">
                      <FormGroup>
                        <Label className="form-control-label">
                          Organization Name{" "}
                        </Label>
                        <span className="text-danger"> *</span>
                        <Input
                          name="organizationName"
                          placeholder="Enter origanization name"
                          value={addChannelFormData.organizationName.value}
                          maxLength={100}
                          onChange={(e) =>
                            handleInputChange(
                              "organizationName",
                              e.target.value,
                            )
                          }
                          onBlur={(e) =>
                            handleOnBlur(e.target.name, e.target.value)
                          }
                          className={
                            addChannelFormData.organizationName.error
                              ? "is-invalid"
                              : ""
                          }
                        />
                        {addChannelFormData.organizationName.error && (
                          <div className="invalid-feedback d-block">
                            {addChannelFormData.organizationName.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>

                    <Col md="4">
                      <FormGroup>
                        <Label className="form-control-label">
                          Contact Person First Name{" "}
                        </Label>
                        <span className="text-danger"> *</span>
                        <Input
                          placeholder="Enter contact person first name"
                          name="contactPersonFirstName"
                          value={
                            addChannelFormData.contactPersonFirstName.value
                          }
                          maxLength={50}
                          onChange={(e) =>
                            handleInputChange(
                              "contactPersonFirstName",
                              e.target.value,
                            )
                          }
                          onBlur={(e) =>
                            handleOnBlur(e.target.name, e.target.value)
                          }
                          className={
                            addChannelFormData.contactPersonFirstName.error
                              ? "is-invalid"
                              : ""
                          }
                        />
                        {addChannelFormData.contactPersonFirstName.error && (
                          <div className="invalid-feedback d-block">
                            {addChannelFormData.contactPersonFirstName.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                    <Col md="4">
                      <FormGroup>
                        <Label className="form-control-label">
                          Contact Person Last Name{" "}
                        </Label>
                        <span className="text-danger"> *</span>
                        <Input
                          name="contactPersonLastName"
                          placeholder="Enter contact person last name"
                          value={addChannelFormData.contactPersonLastName.value}
                          onChange={(e) =>
                            handleInputChange(
                              "contactPersonLastName",
                              e.target.value,
                            )
                          }
                          maxLength={50}
                          onBlur={(e) =>
                            handleOnBlur(e.target.name, e.target.value)
                          }
                          className={
                            addChannelFormData.contactPersonLastName.error
                              ? "is-invalid"
                              : ""
                          }
                        />
                        {addChannelFormData.contactPersonLastName.error && (
                          <div className="invalid-feedback d-block">
                            {addChannelFormData.contactPersonLastName.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="4">
                      <FormGroup>
                        <Label className="form-control-label">Email</Label>
                        <span className="text-danger"> *</span>
                        <Input
                          placeholder="Enter email"
                          name="contactPersonEmail"
                          value={addChannelFormData.contactPersonEmail.value}
                          onChange={(e) =>
                            handleInputChange(
                              "contactPersonEmail",
                              e.target.value,
                            )
                          }
                          maxLength={100}
                          onBlur={(e) =>
                            handleOnBlur(e.target.name, e.target.value)
                          }
                          className={
                            addChannelFormData.contactPersonEmail.error
                              ? "is-invalid"
                              : ""
                          }
                        />
                        {addChannelFormData.contactPersonEmail.error && (
                          <div className="invalid-feedback d-block">
                            {addChannelFormData.contactPersonEmail.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>

                    <Col md="4">
                      <FormGroup>
                        <Label className="form-control-label">
                          Mobile Number
                        </Label>
                        <span className="text-danger"> *</span>
                        <Input
                          placeholder="Enter mobile number"
                          name="contactPersonMobile"
                          maxLength={10}
                          value={addChannelFormData.contactPersonMobile.value}
                          onChange={(e) => {
                            handleInputChange(
                              "contactPersonMobile",
                              e.target.value,
                            );
                          }}
                          onBlur={(e) =>
                            handleOnBlur(e.target.name, e.target.value)
                          }
                          className={
                            addChannelFormData.contactPersonMobile.error
                              ? "is-invalid"
                              : ""
                          }
                        />
                        {addChannelFormData.contactPersonMobile.error && (
                          <div className="invalid-feedback d-block">
                            {addChannelFormData.contactPersonMobile.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>

                    <Col md="4">
                      <FormGroup>
                        <Label className="form-control-label">
                          Status <span className="text-danger"> *</span>
                        </Label>

                        <div className="d-flex mt-2">
                          <FormGroup check className="mr-4">
                            <Label check>
                              <Input
                                type="radio"
                                name="status"
                                className="cursor"
                                checked={
                                  addChannelFormData.status.value === "ACTIVE"
                                }
                                onChange={() =>
                                  handleInputChange("status", "ACTIVE")
                                }
                              />
                              Active
                            </Label>
                          </FormGroup>

                          <FormGroup check>
                            <Label check>
                              <Input
                                type="radio"
                                name="status"
                                className="cursor"
                                checked={
                                  addChannelFormData.status.value === "INACTIVE"
                                }
                                onChange={() =>
                                  handleInputChange("status", "INACTIVE")
                                }
                              />
                              Inactive
                            </Label>
                          </FormGroup>
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
              </Collapse>
            </Card>

            {/* business details */}
            <Card className="mb-3">
              <CardHeader>
                <SectionHeader
                  title="Organization Details"
                  isOpen={open.business}
                  onClick={() => toggle("business")}
                />
              </CardHeader>
              <Collapse isOpen={open.business}>
                <CardBody>
                  <Row>
                    <Col md="4">
                      <FormGroup>
                        <Label className="form-control-label">
                          GST Number{" "}
                        </Label>
                        <span className="text-danger"> *</span>
                        <Input
                          name="gstNo"
                          placeholder="Enter gst number"
                          maxLength={15}
                          value={addChannelFormData.gstNo.value}
                          onChange={(e) =>
                            handleInputChange("gstNo", e.target.value)
                          }
                          onBlur={(e) =>
                            handleOnBlur(e.target.name, e.target.value)
                          }
                          className={
                            addChannelFormData.gstNo.error ? "is-invalid" : ""
                          }
                        />
                        {addChannelFormData.gstNo.error && (
                          <div className="invalid-feedback d-block">
                            {addChannelFormData.gstNo.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>

                    <Col md="4">
                      <FormGroup>
                        <Label className="form-control-label">
                          PAN Number{" "}
                        </Label>
                        <span className="text-danger"> *</span>
                        <Input
                          placeholder="Enter pan number"
                          name="panNo"
                          value={addChannelFormData.panNo.value}
                          maxLength={10}
                          onChange={(e) =>
                            handleInputChange("panNo", e.target.value)
                          }
                          onBlur={(e) =>
                            handleOnBlur(e.target.name, e.target.value)
                          }
                          className={
                            addChannelFormData.panNo.error ? "is-invalid" : ""
                          }
                        />
                        {addChannelFormData.panNo.error && (
                          <div className="invalid-feedback d-block">
                            {addChannelFormData.panNo.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>

                    <Col md="4">
                      <FormGroup>
                        <Label className="form-control-label">
                          Address Line 1 <span className="text-danger"> *</span>
                        </Label>
                        <Input
                          name="lineOne"
                          placeholder="Enter flat / building / street"
                          value={addChannelFormData.lineOne.value}
                          onChange={(e) =>
                            handleInputChange("lineOne", e.target.value)
                          }
                          onBlur={(e) =>
                            handleOnBlur(e.target.name, e.target.value)
                          }
                          className={
                            addChannelFormData.lineOne.error ? "is-invalid" : ""
                          }
                          maxLength={150}
                        />
                        {addChannelFormData.lineOne.error && (
                          <div className="invalid-feedback d-block">
                            {addChannelFormData.lineOne.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>

                    <Col md="4">
                      <FormGroup>
                        <Label className="form-control-label">
                          Address Line 2
                        </Label>
                        <Input
                          name="lineTwo"
                          placeholder="Enter area / locality"
                          value={addChannelFormData.lineTwo.value}
                          onChange={(e) =>
                            handleInputChange("lineTwo", e.target.value)
                          }
                          onBlur={(e) =>
                            handleOnBlur(e.target.name, e.target.value)
                          }
                          maxLength={150}
                          className={
                            addChannelFormData.lineTwo.error ? "is-invalid" : ""
                          }
                        />
                        {addChannelFormData.lineTwo.error && (
                          <div className="invalid-feedback d-block">
                            {addChannelFormData.lineTwo.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>

                    <Col md="4">
                      <FormGroup>
                        <Label className="form-control-label">Landmark</Label>
                        <Input
                          name="landmark"
                          placeholder="Enter nearby landmark"
                          value={addChannelFormData.landmark.value}
                          onChange={(e) =>
                            handleInputChange("landmark", e.target.value)
                          }
                          onBlur={(e) =>
                            handleOnBlur(e.target.name, e.target.value)
                          }
                          maxLength={150}
                          className={
                            addChannelFormData.landmark.error ? "is-invalid" : ""
                          }
                        />
                        {addChannelFormData.landmark.error && (
                          <div className="invalid-feedback d-block">
                            {addChannelFormData.landmark.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>

                    <Col md="4" sm="12">
                      <FormGroup>
                        <Label className="form-control-label">State</Label>
                        <span className="text-danger"> *</span>
                        <Select
                          options={stateOptions}
                          placeholder="Select state"
                          classNamePrefix="react-select"
                          value={stateOptions.find(
                            (opt) =>
                              opt.value === addChannelFormData.stateID.value,
                          )}
                          onChange={(selected) => {
                            const value = selected?.value || "";

                            handleInputChange("stateID", value);

                            if (value) {
                              fetchCitiesForState(value);
                            }
                          }}
                          styles={SELECT_CUSTOM_STYLES}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          isClearable
                          className={
                            addChannelFormData.stateID.error ? "is-invalid" : ""
                          }
                        />
                        {addChannelFormData.stateID.error && (
                          <div className="invalid-feedback d-block">
                            {addChannelFormData.stateID.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>

                    <Col md="4" sm="12">
                      <FormGroup>
                        <Label className="form-control-label">City</Label>
                        <span className="text-danger"> *</span>
                        <CreatableSelect
                          placeholder="Select city"
                          options={cityOptions}
                          value={addChannelFormData.cityID.value}
                          onChange={(selected) =>
                            handleInputChange("cityID", selected?.value || "")
                          }
                          isDisabled={!addChannelFormData.stateID.value}
                          onAddNew={() => handleOpenCityModal()}
                          className={
                            addChannelFormData.cityID.error ? "is-invalid" : ""
                          }
                        />
                        {addChannelFormData.cityID.error && (
                          <div className="invalid-feedback d-block">
                            {addChannelFormData.cityID.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>

                    <Col md="4" sm="12">
                      <FormGroup>
                        <Label className="form-control-label">Pin code</Label>
                        <span className="text-danger"> *</span>
                        <Input
                          type="text"
                          name="pincode"
                          placeholder="Enter pincode"
                          value={addChannelFormData.pincode.value}
                          maxLength={6}
                          disabled={!addChannelFormData.cityID.value}
                          onChange={(e) =>
                            handleInputChange("pincode", e.target.value)
                          }
                          onBlur={(e) =>
                            handleOnBlur(e.target.name, e.target.value)
                          }
                          className={
                            addChannelFormData.pincode.error ? "is-invalid" : ""
                          }
                        />
                        {addChannelFormData.pincode.error && (
                          <div className="invalid-feedback d-block">
                            {addChannelFormData.pincode.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
              </Collapse>
            </Card>

            {/* documents details */}
            <Card className="mb-3">
              <CardHeader>
                <SectionHeader
                  title="Branding & Documents"
                  isOpen={open.documents}
                  onClick={() => toggle("documents")}
                />
              </CardHeader>

              <Collapse isOpen={open.documents}>
                <CardBody>
                  <Row className="branding-documents-row">
                    {/* Company Logo */}
                    <Col md={4} sm={12}>
                      <FormGroup className="profile-photo-container mt-0">
                        <Label className="form-control-label">
                          Company Logo
                        </Label>

                        <div
                          className={`profile-photo-upload-channel-partner text-center border rounded p-3 cursor-pointer ${
                            addChannelFormData.companyLogo.error
                              ? "profile-invalid"
                              : ""
                          }`}
                        >
                          {addChannelFormData.companyLogo.value ? (
                            <div className="doc-preview-container position-relative mx-auto">
                              <div 
                                className="doc-preview cursor-pointer"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleViewFile(logoSrc);
                                }}
                              >
                                <img
                                  src={logoSrc}
                                  alt="Logo Preview"
                                  className="doc-image"
                                />
                              </div>
                              <span
                                className="channel-partner-remove-image"
                                onClick={() => handleRemove()}
                              >
                                &times;
                              </span>
                            </div>
                          ) : (
                            <div className="d-flex flex-column align-items-center">
                              <i className="fa fa-cloud-upload fa-2x text-muted"></i>

                              <p className="mb-0 mt-1 muted-label font-size-sm">
                                (Accepted formats: PNG, JPG, JPEG - Max 15MB)
                              </p>

                              <p className="mb-1 muted-label font-size-sm">
                                Click to upload company logo
                              </p>

                              <label
                                htmlFor="companyLogo"
                                className="choose-image-btn btn btn-simple btn-sm m-0"
                              >
                                Choose Image
                              </label>
                            </div>
                          )}

                          <Input
                            type="file"
                            id="companyLogo"
                            accept="image/*"
                            className="d-none"
                            onChange={(e) =>
                              handleImageChange(e.target.files[0])
                            }
                          />
                        </div>
                        {addChannelFormData.companyLogo.error && (
                          <div className="invalid-feedback d-block">
                            {addChannelFormData.companyLogo.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>

                    {/* Supporting Documents*/}
                    <Col md={7} sm={12}>
                      <FormGroup>
                        <Label className="form-control-label">
                          Supporting Documents
                        </Label>

                        <div
                          className={`product-image-upload w-100 p-3 border rounded text-center cursor ${
                            addChannelFormData.supportingDocuments.error
                              ? "profile-invalid"
                              : ""
                          }`}
                        >
                          {addChannelFormData.supportingDocuments.value.length >
                          0 ? (
                            <div className="d-flex flex-wrap align-items-start">
                              {addChannelFormData.supportingDocuments.value.map(
                                (item, index) => {
                                  const isString = typeof item === "string";
                                  const isPdf = isString
                                    ? item.toLowerCase().endsWith(".pdf")
                                    : item.type === "application/pdf";

                                  // src for images: if string assume backend/public path, otherwise use preview created via URL.createObjectURL
                                  const imgSrc = isString
                                    ? `/uploads/${item}`
                                    : item.preview;

                                  return (
                                      <div
                                        key={index}
                                        className="position-relative mr-3 mb-3"
                                      >
                                        <div className="doc-preview-container">
                                          <div 
                                            className="doc-preview cursor-pointer"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              handleViewFile(imgSrc, item.type);
                                            }}
                                          >
                                            {isPdf ? (
                                              <div className="pdf-preview">
                                                <i className="fa fa-file-pdf text-danger fa-4x"></i>
                                              </div>
                                            ) : (
                                              <img
                                                src={imgSrc}
                                                className="doc-image"
                                                alt="Document"
                                              />
                                            )}
                                          </div>
                                        </div>

                                        <span
                                          className="channel-partner-remove-image"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            removeDocument(index);
                                          }}
                                        >
                                          &times;
                                        </span>
                                      </div>
                                  );
                                },
                              )}

                              {/* Add more only if less than 5 */}
                              {addChannelFormData.supportingDocuments.value
                                .length < 5 && (
                                <div
                                  className="add-more-container"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    document
                                      .getElementById("supportingDocs")
                                      .click();
                                  }}
                                >
                                  <div className="add-more-file-wrapper">+</div>
                                  <span className="small">Add more</span>
                                </div>
                              )}
                            </div>
                          ) : (
                            <div className="d-flex flex-column align-items-center">
                              <i className="fa fa-cloud-upload fa-2x text-muted"></i>

                              <p className="mb-0 mt-1 muted-label font-size-sm">
                                (Accepted formats: PDF, PNG, JPG, JPEG - Max
                                15MB)
                              </p>

                              <p className="mb-1 muted-label font-size-sm">
                                Click to upload documents
                              </p>

                              <label
                                htmlFor="supportingDocs"
                                className="choose-image-btn btn btn-simple btn-sm m-0"
                              >
                                Choose Files
                              </label>
                            </div>
                          )}
                        </div>

                        {addChannelFormData.supportingDocuments.error && (
                          <div className="invalid-feedback d-block">
                            {addChannelFormData.supportingDocuments.error}
                          </div>
                        )}

                        {/* Hidden Input */}
                        <Input
                          type="file"
                          id="supportingDocs"
                          multiple
                          accept="image/*,application/pdf"
                          className="d-none"
                          onClick={(e) => e.stopPropagation()}
                          onChange={handleSupportingDocsChange}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
              </Collapse>
            </Card>

            <Row className="mt-5 mr-4 mb-6">
              <Col className="text-right">
                <Button
                  color="secondary"
                  className="mr-2 save-btn-sm"
                  type="button"
                  onClick={handleOnCancel}
                >
                  Cancel
                </Button>

                <Button
                  color="primary"
                  className="btn-deep-blue mr-2 save-btn-sm"
                  type="submit"
                  onClick={handleSave}
                >
                  Save
                  {/* {isSaving ? (
                    <i className="fa fa-spinner fa-spin mr-2"></i>
                  ) : (
                    "Save"
                  )} */}
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
      {showAddCityModal && (
        <AddNewCityModal
          isOpen={showAddCityModal.isopen}
          stateID={showAddCityModal.stateID}
          stateName={showAddCityModal.stateName}
          cityName={newCityName}
          setCityName={setNewCityName}
          onSave={handleSaveNewCity}
          onCancel={handleCancelAddCity}
          showLoader={showLoaderOnCity}
        />
      )}
      <CommonModal
        isOpen={documentModal.isOpen}
        toggle={closeDocument}
        title={documentModal.title}
        size="xl"
        height="80vh"
      >
        {documentModal.url &&
          (documentModal.isPdf ? (
            <iframe
              src={documentModal.url}
              title={documentModal.title}
              width="100%"
              height="100%"
              className="document-preview-iframe"
            />
          ) : (
            <div className="text-center">
              <img
                src={documentModal.url}
                alt={documentModal.title}
                className="img-fluid document-preview-img modal-preview-media"
              />
            </div>
          ))}
      </CommonModal>
    </>
  );
}

export default AddChannelPartner;
